import React from 'react';
import { PlxsButton } from '@plexlogic/plexus-ui';
import { WIZARD_STYLES } from './wizardStyles';

interface FooterNavButton {
  dataTestId: string;
  label: string;
  variant: 'primary' | 'secondary';
  tone?: 'positive' | 'neutral' | 'brand' | 'caution';
  size?: 'sm' | 'md' | 'lg';
  onClick: () => void;
  isDisabled?: boolean;
  isLoading?: boolean;
  isActive?: boolean;
}

interface FooterNavProps {
  backButton?: FooterNavButton;
  continueButton?: FooterNavButton; // Keep for backward compatibility
  nextButton?: FooterNavButton;
  className?: string;
  style?: React.CSSProperties;
  showBorder?: boolean;
}

const WizardFooterNav: React.FC<FooterNavProps> = ({
  backButton,
  continueButton,
  nextButton,
  className,
  style,
  showBorder = false,
}) => {
  // Use nextButton if provided, otherwise fall back to continueButton for backward compatibility
  const forwardButton = nextButton || continueButton;
  
  const containerStyle = {
    ...WIZARD_STYLES.footerNavContainer,
    ...(showBorder ? WIZARD_STYLES.footerNavBorder : {}),
    ...style,
  };

  return (
    <div className={`wizard-footer-nav ${className || ''}`} style={containerStyle}>
      {backButton ? (
        <PlxsButton
          isActive={backButton.isActive}
          dataTestId={backButton.dataTestId}
          label={backButton.label}
          decorativeIcon='arrowLeft'
          variant="primary"
          tone="positive"
          size={backButton.size || 'lg'}
          onClick={backButton.onClick}
          isDisabled={backButton.isDisabled}
          isLoading={backButton.isLoading}
        />
      ) : (
        <div /> // Spacer to maintain right alignment
      )}
      
      {forwardButton && (
        <PlxsButton
          isActive={forwardButton.isActive}
          dataTestId={forwardButton.dataTestId}
          label={forwardButton.label}
          functionalIcon='arrowRight'
          variant={forwardButton.variant}
          tone={forwardButton.tone || 'positive'}
          size={forwardButton.size || 'lg'}
          onClick={forwardButton.onClick}
          isDisabled={forwardButton.isDisabled}
          isLoading={forwardButton.isLoading}
        />
      )}
    </div>
  );
};

export default WizardFooterNav;
